import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
const styles = theme => ({
  initialsContainer: {
    height: '40px',
    width: '40px',
    borderRadius: '4px',
    backgroundColor: '#EBEEF1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'rgba(12,31,44,0.38)',
    fontFamily: theme.typography.font.main,
    fontWeight: '500',
    fontSize: '16px',
    letterSpacing: '1px',
    lineHeight: '24px'
  }
});

export class CommentInitialsBox extends PureComponent {
  static propTypes = {
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired
  };

  render() {
    const { firstName, lastName, classes } = this.props;
    const initials = String(
      `${firstName.charAt(0)}${lastName.charAt(0)}`
    ).toUpperCase();

    return <div className={classes.initialsContainer}>{initials}</div>;
  }
}
export default withStyles(styles)(CommentInitialsBox);
